var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    width: 141,
    height: 53,
    viewBox: "0 0 141 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1f3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003562"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18852",
    "data-name": "Group 18852",
    transform: "translate(7676 9816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18851",
    "data-name": "Group 18851",
    transform: "translate(-7688 -10719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18849",
    "data-name": "Group 18849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18843",
    "data-name": "Group 18843",
    transform: "translate(-10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18845",
    "data-name": "Group 18845"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6219",
    "data-name": "Rectangle 6219",
    width: 141,
    height: 53,
    rx: 5,
    transform: "translate(22 893)",
    opacity: 0.65,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18842",
    "data-name": "Group 18842",
    transform: "translate(33.545 912.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41023",
    "data-name": "Path 41023",
    d: "M268.349,85.43a1.7,1.7,0,1,1-2.987,1.64l-4.771-8.69a1.7,1.7,0,1,1,2.987-1.64ZM289.113,89.3l-7.5-12.609a1.694,1.694,0,0,0-.806-.7h0q-.072-.03-.147-.054l-.031-.01q-.059-.017-.118-.03l-.056-.011-.1-.015-.075-.008-.082,0h-.087l-.071,0c-.033,0-.065,0-.1.009l-.059.008q-.056.009-.111.021l-.042.01q-.066.016-.13.038l-.019.007a1.7,1.7,0,0,0-.932.787l-3.277,5.969L272.1,76.74a1.7,1.7,0,1,0-2.987,1.64l4.321,7.87-4.321,7.87a1.7,1.7,0,1,0,2.987,1.64l3.277-5.969,3.277,5.969a1.7,1.7,0,1,0,2.987-1.64l-4.321-7.87,2.888-5.261,5.976,10.051a1.7,1.7,0,0,0,2.929-1.742Zm1.257,3.6a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,290.369,92.895Z",
    transform: "translate(-260.38 -75.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39645",
    "data-name": "Path 39645",
    d: "M80.237,442.6l2.267-8.681H85l-3.472,12.56H79.015l-2.87-8.946-2.87,8.946H70.724l-3.49-12.56H69.82l2.3,8.645,2.781-8.645h2.533Z",
    transform: "translate(-30.513 -425.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39646",
    "data-name": "Path 39646",
    d: "M261.6,479.554v-.106a2.3,2.3,0,0,1-.939,1.036,2.839,2.839,0,0,1-1.506.4,3.952,3.952,0,0,1-3.082-1.32,4.78,4.78,0,0,1-1.187-3.322,4.718,4.718,0,0,1,1.169-3.26,3.871,3.871,0,0,1,3.029-1.311,2.948,2.948,0,0,1,1.665.416,2.182,2.182,0,0,1,.833.912v-1.081h2.285v7.139q0,.8.071,1.577h-2.25A6.13,6.13,0,0,1,261.6,479.554Zm-3.729-5.164a2.672,2.672,0,0,0-.611,1.851,2.81,2.81,0,0,0,.611,1.887,1.966,1.966,0,0,0,1.568.717,1.923,1.923,0,0,0,1.541-.717,2.837,2.837,0,0,0,.6-1.887,2.724,2.724,0,0,0-.594-1.851,1.957,1.957,0,0,0-1.55-.682A2.011,2.011,0,0,0,257.868,474.39Z",
    transform: "translate(-200.287 -459.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39647",
    "data-name": "Path 39647",
    d: "M366.9,486.428h-2.5l2.055-4.535-3.7-7.618h2.64l2.321,5.1,2.144-5.1h2.516Z",
    transform: "translate(-297.879 -462.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39648",
    "data-name": "Path 39648",
    d: "M494.67,446.478h-2.409v-8.8l-3.614,8.8h-2.037L483,437.745v8.734h-2.338v-12.56h3.224l3.773,9.07,3.685-9.07h3.331Z",
    transform: "translate(-404.554 -425.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39649",
    "data-name": "Path 39649",
    d: "M649.894,472.8a4.73,4.73,0,0,1,6.537,0,4.865,4.865,0,0,1,0,6.626,4.73,4.73,0,0,1-6.537,0,4.865,4.865,0,0,1,0-6.626Zm1.7,5.138a2.2,2.2,0,0,0,3.136,0,2.9,2.9,0,0,0,0-3.649,2.2,2.2,0,0,0-3.136,0,2.9,2.9,0,0,0,0,3.649Z",
    transform: "translate(-556.492 -459.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39650",
    "data-name": "Path 39650",
    d: "M769.4,473.566v2.374a3.622,3.622,0,0,0-.709-.071,2.3,2.3,0,0,0-1.63.576,2.475,2.475,0,0,0-.62,1.887v3.986h-2.356V473.6h2.285v1.293a2.469,2.469,0,0,1,2.48-1.364Q769.043,473.531,769.4,473.566Z",
    transform: "translate(-660.981 -461.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39651",
    "data-name": "Path 39651",
    d: "M836.045,477.384l1.966.585a3.759,3.759,0,0,1-1.391,1.984,4.167,4.167,0,0,1-2.578.78,4.418,4.418,0,0,1-3.189-1.267,4.981,4.981,0,0,1-.035-6.7,4.1,4.1,0,0,1,3.012-1.284,4.149,4.149,0,0,1,3.162,1.2A4.618,4.618,0,0,1,838.136,476q0,.142-.009.319c-.006.118-.009.213-.009.283l-.018.124h-6.236a1.932,1.932,0,0,0,.673,1.417,2.215,2.215,0,0,0,1.523.567A1.91,1.91,0,0,0,836.045,477.384Zm-4.128-2.268h3.9a1.812,1.812,0,0,0-.523-1.222,1.914,1.914,0,0,0-1.426-.5,1.87,1.87,0,0,0-1.382.532A1.787,1.787,0,0,0,831.918,475.117Z",
    transform: "translate(-720.207 -459.738)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18848",
    "data-name": "Group 18848",
    transform: "translate(38 -75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18844",
    "data-name": "Group 18844",
    transform: "translate(1.282 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18839",
    "data-name": "Group 18839",
    transform: "translate(3701 10078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_45_8",
    "data-name": "Component 45 \\uFFFD\\uFFFD\\uFFFD 8",
    transform: "translate(-3650.53 -9087.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TITLE_BIG",
    "data-name": "TITLE BIG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41785",
    "data-name": "Path 41785",
    d: "M19.47,11h.7V5.51L22.63,11h.51L25.6,5.49V11h.7V4.1h-.75l-2.67,5.98L20.21,4.1h-.74Zm8.24-2.74a2.6,2.6,0,0,0,2.6,2.82,2.307,2.307,0,0,0,2.17-1.29V11h.7V5.54h-.7v1.2a2.279,2.279,0,0,0-2.16-1.28A2.579,2.579,0,0,0,27.71,8.26Zm4.77.01a2.037,2.037,0,1,1-4.06-.01,1.993,1.993,0,0,1,2.03-2.19A2.034,2.034,0,0,1,32.48,8.27Zm2.12-.01a2.6,2.6,0,0,0,2.61,2.82,2.277,2.277,0,0,0,2.16-1.3V11h.7V3.6h-.7V6.72a2.374,2.374,0,0,0-2.15-1.26A2.582,2.582,0,0,0,34.6,8.26Zm4.77.01a2.037,2.037,0,1,1-4.06-.01,1.993,1.993,0,0,1,2.03-2.19A2.034,2.034,0,0,1,39.37,8.27Zm4.77-2.21a1.786,1.786,0,0,1,1.9,1.91H42.2A1.885,1.885,0,0,1,44.14,6.06Zm2.53,3.21h-.74a1.69,1.69,0,0,1-1.76,1.22A1.909,1.909,0,0,1,42.2,8.54h4.53a4.788,4.788,0,0,0,.02-.55,2.455,2.455,0,0,0-2.58-2.53,2.587,2.587,0,0,0-2.68,2.81,2.6,2.6,0,0,0,2.68,2.81A2.4,2.4,0,0,0,46.67,9.27ZM52.11,11h.71l1.51-4.58L55.84,11h.7l1.71-5.46h-.69L56.21,10.3,54.7,5.54H54l-1.53,4.75L51.11,5.54H50.4Zm7.23,0h.7V5.54h-.7Zm.35-6.49a.508.508,0,0,0,.51-.52.51.51,0,1,0-1.02,0A.508.508,0,0,0,59.69,4.51Zm2.28,5.01c0,1.09.51,1.48,1.46,1.48h.75v-.6h-.64c-.63,0-.86-.21-.86-.88V6.13h1.5V5.54h-1.5V4.17h-.71V5.54h-.76v.59h.76ZM65.47,11h.7V8.02c0-1.33.71-1.97,1.73-1.97a1.6,1.6,0,0,1,1.66,1.83V11h.69V7.8a2.105,2.105,0,0,0-2.18-2.36,2.055,2.055,0,0,0-1.9,1.03V3.6h-.7Z",
    transform: "translate(-19.47 -3.48)",
    fill: "#fff"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.8cde19d6299d99d551f039c9ec694289.svg";
export { ForwardRef as ReactComponent };